import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

function AllUsersSection({ users, onUserAssignmentClick }) {
  return (
    <div className="common-form-group">
      <h4>All Users ({users.length})</h4>
      <div className="users-container">
        {users.map((user) => (
          <div key={user.userId} className="info-item user-summary-card">
            <div className="user-summary-content">
              <div className="user-summary-left">
                <FontAwesomeIcon icon={faUser} />
                <div>
                  <div className="user-summary-name">
                    {user.firstName} {user.lastName}
                  </div>
                  <div className="user-summary-email">{user.email}</div>
                </div>
              </div>
              <div className="user-summary-right">
                <div className="user-summary-group">{user.groupName}</div>
                <div className="user-summary-org">{user.orgName}</div>
                <div className="user-summary-status">
                  {user.isVerified ? (
                    <span className="verified">✓ Verified</span>
                  ) : (
                    <span className="not-verified">✗ Not Verified</span>
                  )}
                  {" | "}
                  <span className={user.isActive ? "active" : "inactive"}>
                    {user.isActive ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AllUsersSection;
